/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misty_Slimy_Worm_SingInputs */

const fr_misty_slimy_worm_sing = /** @type {(inputs: Misty_Slimy_Worm_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercice`)
};

/**

* @param {Misty_Slimy_Worm_SingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const misty_slimy_worm_sing = /** @type {((inputs?: Misty_Slimy_Worm_SingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misty_Slimy_Worm_SingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_misty_slimy_worm_sing(inputs)
});